import { VOMarker } from "../model/DataStructure";

export interface MarkerContentOptions {
    container: HTMLElement;
    onClose: () => void;
    onPrev: () => void;
    onNext: () => void;
}

export class MarkerContent {

    public onClose = e5.Signal.create();
    public onNext = e5.Signal.create();
    public onPrev = e5.Signal.create();

    private readonly _element: HTMLDivElement;
    private _marker: VOMarker = null;

    constructor(options: MarkerContentOptions) {
        options = e5.object.merge({
        }, options);

        this._element = document.createElement("div");
        this._element.className = "awi-marker-content awi-marker-content--hidden";
        this._element.innerHTML = `
        <div class="awi-marker-content__header">
            <div class="awi-marker-content__header-content container">
                <div class="awi-marker-content__title">
                    <div class="awi-marker-content__index"></div>
                    <div class="awi-marker-content__label"></div>
                </div>
                <div class="awi-marker-content__control">
                    <div class="awi-marker-content__icon fal fa-times" data-action="close"></div>
                </div>
            </div>
        </div>
        <div class="awi-marker-content__body awi-base__scrollbar">
            <div class="awi-marker-content__container container">
                <div class="awi-marker-content__text"></div>
                <div class="awi-marker-content__image-wrapper">
                    <img class="awi-marker-content__image" src="" />
                </div>
            </div>
        </div>        
        `;
        options.container.appendChild(this._element);

        const swipe = new e5.Swipe(this._element, {

        });
        swipe.onSwipe.add((direction) => {
            if(direction === "left"){
                this.onNext.dispatch();
            }
            else if(direction === "right"){
                this.onPrev.dispatch();
            }
        })

        if (typeof options.onClose === "function") {
            this.onClose.add(options.onClose);
        }

        if (typeof options.onPrev === "function") {
            this.onPrev.add(options.onPrev);
        }

        if (typeof options.onNext === "function") {
            this.onNext.add(options.onNext);
        }

        e5.event.on({
            type: "click",
            listener: (e) => {
                this.onClose.dispatch();
            },
            scope: this._element,
            selector: `[data-action="close"]`
        });

        e5.event.on({
            type: "click",
            listener: (e) => {
                this.onPrev.dispatch();
            },
            scope: this._element,
            selector: `[data-action="prev"]`
        });

        e5.event.on({
            type: "click",
            listener: (e) => {
                this.onNext.dispatch();
            },
            scope: this._element,
            selector: `[data-action="next"]`
        });
    }

    public get selected(): boolean {
        return this._element.classList.contains("awi-marker-content--selected");
    }

    public set selected(value: boolean) {
        this._element.classList.toggle("awi-marker-content--selected", value);
    }

    public get visible(): boolean {
        return !this._element.classList.contains("awi-marker-content--hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("awi-marker-content--hidden", !value);
    }

    public get marker(): VOMarker {
        return this._marker;
    }

    public set marker(value: VOMarker) {
        if (this._marker?.id == value?.id) {
            return;
        }
        this._marker = value;

        this._element.querySelector(".awi-marker-content__body")
            .scrollTop = 0;

        if (value) {

            this._element.querySelector(".awi-marker-content__image-wrapper")
            .classList.toggle("e5-hidden", !value.image);


            if(value.image){
                this._element.querySelector<HTMLImageElement>(".awi-marker-content__image")
                .src = value.image.sizes["medium"];
            }

            this._element.querySelector(".awi-marker-content__title")
                .textContent = value.name;

            this._element.querySelector(".awi-marker-content__text")
                .innerHTML = value.text;//e5.Text.loremIpsum(100, true);//
        }

        this.visible = Boolean(value);
    }
}